common.View.create('canvas.blocks.custom.header.Block', {

    onDOMLoad() {
        this.initHamburger();
    },

    initHamburger() {
        let hamburger = this.element.find('.hamburger');
        let mobileMenu = this.element.find('.mobile-menu');

        hamburger.on('click', () => {
            hamburger.toggleClass('is-active');
            mobileMenu.toggleClass('hidden');
        });
    }

});
